import CascadedSelect from '../cascaded_select.js';
import CheckBox from '../checkbox.js';
import DateTime from '../datetime.js';
import FileField from '../file.js';
import Integer from '../integer.js';
import Location from '../location.js';
import Member from '../member.js';
import Organization from '../organization.js';
import RadioButton from '../radio.js';
import Rating from '../rating.js';
import SectionBreak from '../section_break.js';
import TextField from '../text.js';
import TextArea from '../textarea.js';
import IDNumber from '../idnumber.js';
import Phone from '../phone.js';
import Calculation from '../calculation.js';
import FieldListMixin from './mixin.js';

const AVAIABLE_FIELDS_COMPONENTS = {
  CascadedSelect,
  CheckBox,
  DateTime,
  FileField,
  Integer,
  Location,
  Member,
  Organization,
  RadioButton,
  Rating,
  SectionBreak,
  TextField,
  TextArea,
  IDNumber,
  Phone,
  Calculation,
};

export default Vue.extend({
  mixins: [FieldListMixin],

  methods: {
    _getComponent(field) {
      const type = field.type.demodulize();

      return AVAIABLE_FIELDS_COMPONENTS[type]
        || AVAIABLE_FIELDS_COMPONENTS[`${type}Field`]
        || TextField;
    },
  },
});
